import {
    Dialog,
    Toast
} from "vant";

import {
    ORDER_PARKING_GET_ORDER_STATUS,
    ABNORMAL_ORDER_MSG,
    ORDER_PARKING_SYNC_ORDER_INFO,
} from '../config/config';

const payBtnDelay = 1000; //(ms)   开启支付按钮延时
const maxCount = 9; //(次)  最大轮询次数
const pollRequestDelay = 5000;

const payMixin = {
    data: () => ({
        showQRCode: false, //是否展示二维码
        isScanning: false, //支付按钮是否可用
        isPaying: false, //是否支付中
        count: false, //轮询次数

        orderParkingId: '',
        stationId : '' ,
        paymentNoteId: "",
        scanCodeInterface: '',
        orderAmount: '',
    }),

    methods: {
        //点击支付
        onPay(id) {
            if (id) {
                //关闭付款二维码页面
                this.closeQRCode();

                //防抖
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                //开始扫码，禁用支付按钮
                this.isScanning = true;

                this.timeout = setTimeout(() => {
                    this.timeout = null;

                    //定时开启支付按钮
                    this.payingTimeout = setTimeout(() => {
                        this.isScanning = false;
                    }, payBtnDelay);

                    //调二维码扫描页面
                    this.$utils.scanQRCode(id, (decodeContent) => {
                        // Toast(`拿到二维码支付内容 = ${decodeContent}，调用支付接口`);

                        //显示加载
                        this.$utils.showLoading();
                        this.isPaying = true;

                        // 发起扫描二维码请求
                        this.scanQRCodeRequest(decodeContent, (res) => {

                            //判断是否请求成功
                            if (this.$condition.isRequestSuccess(res)) {

                                this.paymentNoteId = res['data']['paymentNoteId'];

                                //判断订单状态操作
                                this.orderStatusWatchFunc(res["data"]["result"]);

                            } else {

                                //请求结束
                                this.pollRequestFinish();
                            }
                        });
                    });
                }, 0);
            }

        },

        //扫描二维码请求
        scanQRCodeRequest(decode, callback) {
            if (decode) {
                let params = {
                    qrcode: decode,
                    orderParkingId: this.orderParkingId,
                };
                if (this.stationId) {
                    params = {
                        ...params,
                        stationId: this.stationId,
                    }
                }
                this.$request(
                    this.scanCodeInterface, params,
                    (res) => {
                        callback(res);
                    }
                );
            }
        },

        orderStatusWatchFunc(code) {
            this.count = 0;
            this.orderStatusFunc(code, () => {
                //开始轮询
                this.pollRequest();
            });
        },

        //验证订单状态，做回调函数，封装便于重复调用
        orderStatusFunc(
            orderStatus,
            abnormalCallback,

        ) {
            // Toast(orderStatus + '');

            if (this.$condition.isOrderStatus_abnormal(orderStatus) ||
                this.$condition.isOrderStatus_arrears(orderStatus)) {
                // 订单支付中
                abnormalCallback();
            } else if (this.$condition.isOrderStatus_fail(orderStatus)) {


                // 订单支付失败
                this.pollRequestFinish();

                // let isRecovery = this.isRecovery ? true : false ;

                this.isFirst = true;
                //支付失败时
                // this.$router.replace({
                //     name: "Result",
                //     params: {
                //         orderStatus: this.orderStatus + "",
                //         oid: this.orderParkingId,
                //         orderAmount: this.orderAmount,
                //         isRecovery
                //     },
                // });
                this.failCallback();

            } else if (this.$condition.isOrderStatus_success(orderStatus)) {

                // 订单支付成功
                this.pollRequestFinish();
                // this.$utils.goBack();
                // this.$utils.orderParkingId(this.orderParkingId);
                this.successCallback();
            } else {
                //关闭加载
                this.pollRequestFinish();
                Toast("订单状态错误，请联系客服");
            }
        },

        //轮询订单状态
        pollRequest() {
            //当请求次数小于maxCount次
            if (this.count < maxCount) {
                this.$request(
                    ORDER_PARKING_GET_ORDER_STATUS, {
                        paymentNoteId: this.paymentNoteId
                    },
                    (res) => {
                        //请求接口成功
                        if (this.$condition.isRequestSuccess(res)) {
                            //请求次数+1
                            this.count++;

                            this.orderStatusFunc(
                                res["data"],
                                () => {
                                    //还在支付中状态 , 继续请求;
                                    if (this.pollRequestTimeout) {
                                        clearTimeout(this.pollRequestTimeout);
                                    }
                                    //返回轮询方法，继续查询
                                    return (this.pollRequestTimeout = setTimeout(() => {
                                        this.pollRequest();
                                    }, pollRequestDelay));
                                }
                            );
                        } else {
                            //请求失败
                            this.pollRequestFinish();
                        }
                    }
                );
            } else {
                this.pollRequestFinish();
                //订单状态异常
                this.autoSyncOrderInfo();
            }
        },

        //同步订单操作
        autoSyncOrderInfo() {
            Dialog.alert({
                title: '系统提示',
                message: `<span style="font-size : 20px ;">${ABNORMAL_ORDER_MSG}</span>`,
            }).then(() => {
                // this.exceededPollingTimes();
                this.$request(ORDER_PARKING_SYNC_ORDER_INFO, {
                    paymentNoteId: this.paymentNoteId
                }, res => {
                    if (this.$condition.isRequestSuccess(res)) {
                        this.orderStatusFunc(res["data"], this.autoSyncOrderInfo);
                    }
                })
            });
        },

        //轮询结束操作
        pollRequestFinish() {
            this.$utils.closeLoading();
            if (this.pollRequestTimeout) {
                clearTimeout(this.pollRequestTimeout);
            }
            this.count = 0;
            this.isPaying = false;
        },
    },


}

export default payMixin;